"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.replace");
var _vue = _interopRequireDefault(require("vue"));
_vue.default.directive('Int', {
  inserted: function inserted(el) {
    var input = el.getElementsByTagName('input')[0]; //注意这里element与ant不同   ant为 const input = el.querySelector(el);
    input.onkeyup = function (e) {
      if (input.value != '') {
        el.getElementsByTagName('span')[0].style.display = 'none';
      } else {
        el.getElementsByTagName('span')[0].style.display = 'block';
      }
      input.value = input.value.replace(/[^\d\.]/g, '');
      input.value = input.value.replace(/^\./g, '');
      input.value = input.value.replace(/\.{2,}/g, '.');
      input.value = input.value.replace(/\.{2,}/g, '.');
      input.value = input.value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      input.value = input.value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      input.value = input.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      if (input.value == '00') {
        //输入 000000 时，转成 0 
        input.value = 0;
      }
    };
    input.onblur = function (e) {
      input.value = input.value.replace(/[^\d\.]/g, '');
      input.value = input.value.replace(/^\./g, '');
      input.value = input.value.replace(/\.{2,}/g, '.');
      input.value = input.value.replace(/\.{2,}/g, '.');
      input.value = input.value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      input.value = input.value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      input.value = input.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      if (input.value == '0') {
        //输入0的时候转成空    或者可自行调节   0.00  看需求
        input.value = '';
      }
      if (input.value.split('.')[1] == '') {
        input.value = input.value.split('.')[0];
      }
      if (input.value.substr(0, 1) == '0' && input.value.substr(1, 1) != '.') {
        //把  0123456 的数据转成  123456
        input.value = input.value.substr(1, input.value.length - 1);
      }
    };
  }
});

/** 处理input中的字符 */
var handle = function handle(event) {
  console.log(event);
  if (!event.isTrusted) {
    return;
  }
  var arg = event.target._type;
  if (arg) {
    if (arg.includes('trim')) {
      var _event$target$value;
      event.target.value = (_event$target$value = event.target.value) === null || _event$target$value === void 0 ? void 0 : _event$target$value.trim();
    }
    if (arg.includes('lower')) {
      var _event$target$value2;
      event.target.value = (_event$target$value2 = event.target.value) === null || _event$target$value2 === void 0 ? void 0 : _event$target$value2.toLowerCase();
    }
    if (arg.includes('upper')) {
      var _event$target$value3;
      event.target.value = (_event$target$value3 = event.target.value) === null || _event$target$value3 === void 0 ? void 0 : _event$target$value3.toUpperCase();
    }
    if (arg.includes('trimAll')) {
      var _event$target$value4;
      event.target.value = (_event$target$value4 = event.target.value) === null || _event$target$value4 === void 0 ? void 0 : _event$target$value4.replace(/\s+/g, '');
    }
  } else {
    var _event$target$value5;
    event.target.value = (_event$target$value5 = event.target.value) === null || _event$target$value5 === void 0 ? void 0 : _event$target$value5.trim();
  }
  dispatchEvent(event.target._el);
};
var dispatchEvent = function dispatchEvent(el) {
  // 触发双向绑定
  var evt = document.createEvent('HTMLEvents');
  evt.initEvent('input', true, true);
  el.dispatchEvent(evt);
};
_vue.default.directive('input', {
  inserted: function inserted(el, binding) {
    var _binding$arg;
    var inputEle = el.tagName !== 'INPUT' ? el.querySelector('input') : el;
    var arg = (_binding$arg = binding.arg) === null || _binding$arg === void 0 ? void 0 : _binding$arg.split(',');
    // 黑魔法，传递参数
    inputEle._type = arg;
    inputEle._el = inputEle;
    inputEle.addEventListener('blur', handle);
  },
  unbind: function unbind(el) {
    var inputEle = el.tagName !== 'INPUT' ? el.querySelector('input') : el;
    inputEle.removeEventListener('blur', handle);
  }
});
// 用于处理输入框全角转成半角
_vue.default.directive('fth', {
  bind: function bind(el, binding, vnode) {
    el.addEventListener('input', inputFTHHandler);
    el.addEventListener('blur', inputFTHHandler);
    el.addEventListener('compositionstart', compositionStartHandler);
    el.addEventListener('compositionend', compositionFTHHandler);
  },
  unbind: function unbind(el) {
    el.removeEventListener('input', inputFTHHandler);
    el.removeEventListener('blur', inputFTHHandler);
    el.removeEventListener('compositionstart', compositionStartHandler);
    el.removeEventListener('compositionend', compositionFTHHandler);
  }
});
function inputFTHHandler(e) {
  if (!e.isTrusted) {
    return;
  }
  // 当不是处于复合输入状态时，才转换大写
  if (!e.target.isComposing) {
    e.target.value = e.target.value.replace(/[\uFF01-\uFF5E]/g, function (c) {
      return String.fromCharCode(c.charCodeAt(0) - 0xFEE0);
    }).replace(/\u3000/g, ' ');
    e.target.dispatchEvent(new Event('input'));
  }
}
function compositionFTHHandler(e) {
  e.target.isComposing = false;
  // 复合输入结束后，再次转换大写并触发input事件更新v-model
  inputFTHHandler(e);
}

// 用于处理输入框输入大写字母
_vue.default.directive('uppercase', {
  bind: function bind(el, binding, vnode) {
    el.addEventListener('input', inputUpperHandler);
    el.addEventListener('blur', inputUpperHandler);
    el.addEventListener('compositionstart', compositionStartHandler);
    el.addEventListener('compositionend', compositionUpperHandler);
  },
  unbind: function unbind(el) {
    el.removeEventListener('input', inputUpperHandler);
    el.removeEventListener('blur', inputUpperHandler);
    el.removeEventListener('compositionstart', compositionStartHandler);
    el.removeEventListener('compositionend', compositionUpperHandler);
  }
});
function inputUpperHandler(e) {
  if (!e.isTrusted) {
    return;
  }
  // 当不是处于复合输入状态时，才转换大写
  if (!e.target.isComposing) {
    // 获取当前光标的位置
    var cursorPosition = e.target.selectionStart;
    // 将值转换为大写
    e.target.value = e.target.value.toUpperCase();
    // 将光标移回原来的位置
    e.target.setSelectionRange(cursorPosition, cursorPosition);
    // 由于直接修改了输入框的值，需要手动触发input事件以更新v-model绑定的值
    e.target.dispatchEvent(new Event('input'));
  }
}
function compositionStartHandler(e) {
  e.target.isComposing = true;
}
function compositionUpperHandler(e) {
  e.target.isComposing = false;
  // 复合输入结束后，再次转换大写并触发input事件更新v-model
  inputUpperHandler(e);
}

// 用于处理输入框输入小写字母
_vue.default.directive('lowercase', {
  bind: function bind(el, binding, vnode) {
    el.addEventListener('input', inputLowerHandler);
    el.addEventListener('blur', inputLowerHandler);
    el.addEventListener('compositionstart', compositionStartHandler);
    el.addEventListener('compositionend', compositionLowerHandler);
  },
  unbind: function unbind(el) {
    el.removeEventListener('input', inputLowerHandler);
    el.removeEventListener('blur', inputLowerHandler);
    el.removeEventListener('compositionstart', compositionStartHandler);
    el.removeEventListener('compositionend', compositionLowerHandler);
  }
});
function inputLowerHandler(e) {
  if (!e.isTrusted) {
    return;
  }
  // 当不是处于复合输入状态时，才转换大写
  if (!e.target.isComposing) {
    e.target.value = e.target.value.toLowerCase();
    // 由于直接修改了输入框的值，需要手动触发input事件以更新v-model绑定的值
    e.target.dispatchEvent(new Event('input'));
  }
}
function compositionLowerHandler(e) {
  e.target.isComposing = false;
  // 复合输入结束后，再次转换小写并触发input事件更新v-model
  inputLowerHandler(e);
}
_vue.default.directive('trim', {
  bind: function bind(el) {
    var inputEle = el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' ? el : el.querySelector('input') || el.querySelector('textarea');
    inputEle._blurHandler = function (e) {
      if (!e.isTrusted) {
        return;
      }
      e.target.value = e.target.value.trim();
      e.target.dispatchEvent(new Event('input'));
    };
    inputEle.addEventListener('blur', inputEle._blurHandler);
  },
  unbind: function unbind(el) {
    var inputEle = el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' ? el : el.querySelector('input') || el.querySelector('textarea');
    inputEle.removeEventListener('blur', inputEle._blurHandler);
    inputEle._blurHandler = null;
  }
});